import React from "react";
import AI from "./Components/AIAnalyzer.jsx";

const Analyzer = () => {
  return (
    <div>
      <h1>
        <span class="orangeFixed">Security Scanner</span>
      </h1>
      <div class="container">
        <p>
          Welcome to our dedicated page for code vulnerability analysis. Here,
          you can seamlessly <span class="orangeFixed">paste your code</span>{" "}
          and uncover potential vulnerabilities lurking within it.
        </p>

        <AI />
      </div>
    </div>
  );
};
export default Analyzer;
